var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBankingAndPaymentsCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-4644.000000, -771.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-banking-and-payments/Card",
    transform: "translate(4644.000000, 771.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,23 L29,23 L29,20 L24,20 L24,23 Z M17,23 L22,23 L22,20 L17,20 L17,23 Z M10,23 L15,23 L15,20 L10,20 L10,23 Z M4.187,15.625 C3.531,15.625 3,15.093 3,14.437 L3,11.187 C3,10.532 3.531,10 4.187,10 L9.639,10 C10.295,10 10.826,10.532 10.826,11.187 L10.826,14.437 C10.826,15.093 10.295,15.625 9.639,15.625 L4.187,15.625 Z M3,23 L8,23 L8,20 L3,20 L3,23 Z M31.944,7.457 C31.935,7.403 31.921,7.352 31.908,7.299 C31.877,7.173 31.84,7.051 31.793,6.931 C31.773,6.88 31.755,6.829 31.732,6.778 C31.667,6.634 31.593,6.496 31.507,6.365 C31.498,6.35 31.491,6.334 31.481,6.32 C31.386,6.18 31.276,6.052 31.159,5.93 C31.118,5.887 31.073,5.848 31.029,5.808 C30.944,5.729 30.856,5.655 30.763,5.587 C30.712,5.55 30.661,5.512 30.608,5.478 C30.492,5.404 30.372,5.339 30.246,5.281 C30.213,5.266 30.183,5.246 30.149,5.232 C29.795,5.083 29.407,5 29,5 L3,5 C1.35,5 0,6.35 0,8 L0,24 C0,25.65 1.35,27 3,27 L29,27 C30.65,27 32,25.65 32,24 L32,8 C32,7.814 31.978,7.633 31.944,7.457 L31.944,7.457 Z",
    id: 75
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBankingAndPaymentsCard);
export default __webpack_public_path__ + "static/media/home-banking-and-payments-card.dfc85284.svg";
export { ForwardRef as ReactComponent };